module.exports = __webpack_public_path__ + "img/logoImg.8aeb0fb1.png";